import React from 'react';
import LinearProgressMLStyled from './LinearProgressMLStyled';
import LinearProgress from '@material-ui/core/LinearProgress';

const LinearProgressML = (props) => {
  return (
    <LinearProgressMLStyled color={props.color}>
      <LinearProgress
        variant="determinate"
        classes={{ bar: 'bar' }}
        sx={{ height: '32px', backgroundColor: '#E0E0E0', borderRadius: '0' }}
        value={props.value}
      ></LinearProgress>
    </LinearProgressMLStyled>
  );
};

export default LinearProgressML;
